import CurrencyExchangeOutlined from '@mui/icons-material/CurrencyExchangeOutlined';
import { Stack, ToggleButton, Typography } from '@mui/material';
import { fontWeights } from '@/@mui/tokens/font-weights';
import type { ResourceApproval } from '@/data/subsidy/interfaces';
import { formatDurationWithModality } from '@/utils/format-duration-with-modality';
import { lineClamp } from '@/utils/line-clamp';

interface ResourceApprovalCardProps {
  resourceApproval: ResourceApproval;
  withIcon?: true;
}

export const ResourceApprovalCard = ({
  resourceApproval,
  withIcon,
}: ResourceApprovalCardProps) => {
  const resource = resourceApproval.resource;

  const formattedDuration = formatDurationWithModality(
    resource.course?.duration,
    resource.course?.duration_type,
    resource.course?.modality
  );

  const policy = resourceApproval.policies?.[0];

  return (
    <ToggleButton
      value={resourceApproval?.uuid}
      sx={{ minWidth: 180, width: '100%', height: '100%', textAlign: 'left' }}
    >
      <Stack
        height="100%"
        gap={withIcon ? 2 : 0.5}
        justifyContent="space-between"
      >
        <Stack gap={2}>
          {withIcon && (
            <CurrencyExchangeOutlined
              sx={{ fontSize: 24, color: 'neutral.300' }}
            />
          )}
          <Typography variant="h3" sx={lineClamp(2)}>
            {resourceApproval?.name}
          </Typography>
        </Stack>

        <Stack spacing={withIcon ? 2 : 0.5}>
          <Stack spacing={0.5}>
            <Typography color="neutral.700">
              {resourceApproval?.category}
            </Typography>
            <Typography color="neutral.700">
              {formattedDuration || '-'}
            </Typography>
          </Stack>
          {policy && (
            <Typography sx={lineClamp(2)}>
              <Typography
                component="span"
                fontWeight={fontWeights.fontWeightSemibold}
              >
                Política:{' '}
              </Typography>
              {policy.name}
            </Typography>
          )}
        </Stack>
      </Stack>
    </ToggleButton>
  );
};
